import { Component, OnInit } from '@angular/core';

import { Models } from '@ibexfusion/models';
import { PageAction } from '../../../components/page-actions/page-actions.component';
import { ActivatedRoute, Router } from '@angular/router';
import { OrganisationCustomerService } from '@services/customers/organisation-customer.service';
import { PackageService } from '@services/packages/package.service';
import { DynamicContentEntranceService } from '@services/dynamic-content/dynamic-content-entrance.service';
import { OrganisationService } from '@services/organisations/organisation.service';
import { CompositionService } from '@services/compositions/composition.service';
import * as _ from 'lodash';
import { MessengerService } from '@services/messenger/messenger.service';
import { MyOrganisationService } from '@services/organisations/my-organisation.service';
import { SnackbarService } from '@services/snackbar/snackbar.service';
import { AngieScreensService } from '@services/angie-screens/angie-screens.service';

@Component({
    selector: 'app-organisation-customer-detail',
    templateUrl: './organisation-customer-detail.component.html',
    styleUrls: ['./organisation-customer-detail.component.scss'],
    providers: [OrganisationCustomerService, PackageService, DynamicContentEntranceService, OrganisationService, CompositionService, MyOrganisationService, AngieScreensService],
    standalone: false
})
export class OrganisationCustomerDetailComponent implements OnInit {

  public customer: Models.OrganisationCustomer;
  public customerId;
  public title: string;
  public pageActions: PageAction[];
  public objectKeys = Object.keys;
  public dynamicEntrances = [];

  public uuids;
  public columnsScreen = [
    { prop: 'name' }
  ];
  public paramsScreen = { uuid: [] };

  public columnsPackage = [
    { prop: 'title' },
    { prop: 'tweebie.isDestination', name: 'Destination' }
  ];
  public paramsPackage;

  public compositionIds;
  public columnsComposition = [
    { prop: 'title' },
    { prop: 'importIds.length', name: 'Imports' },
    { prop: 'dynamicContentIds.length', name: 'Dynamic Entrances' },
    { prop: 'snippetIds.length', name: 'Snippets' }
  ];
  public paramsComposition = { _id: [] };

  public columnsDynamicEntrance = [
    { prop: 'title' },
    { prop: 'children.length', name: 'Dynamic Content' }
  ];
  public paramsDynamicEntrance = { OwnerCustomerID: false };

  public isLoaded = true;

  public priceModelMap = {
    'stufe1': 'Native-app',
    'stufe2': 'Native-app, inkl. web-app',
    'stufe3': 'Native-app, inkl. web-app, + standard touch',
    'stufe4': 'All inclusive'
  }

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private organisationCustomerService: OrganisationCustomerService,
    public packageService: PackageService,
    public dynamicContentEntranceService: DynamicContentEntranceService,
    public organisationService: OrganisationService,
    public compositionService: CompositionService,
    public angieScreensService: AngieScreensService,
    private messengerService: MessengerService,
    private myOrganisationService: MyOrganisationService,
    private snackbar: SnackbarService
  ) {
    this.customerId = this.route.snapshot.params['id'];
    this.paramsPackage = { customerId: this.customerId };
    this.paramsDynamicEntrance = { OwnerCustomerID: this.customerId };
  }

  ngOnInit() {
    this.isLoaded = false;
    this.createPageActions();
    this.organisationCustomerService.get(this.customerId).then(response => {
      this.customer = response;
      this.title = 'Customer: ' + response.organisationName;
      this.isLoaded = true;
      this.packageService.find(0, 100, { customerId: this.customerId }).then(packages => {
        if (packages && packages.data) {
          packages.data.map(myPackage => {
            if (!!myPackage.compositionIds) {
              this.compositionIds = _.union(this.compositionIds, myPackage.compositionIds);
            }
            if (!!myPackage.screenUuids) {
              this.uuids = _.union(this.uuids, myPackage.screenUuids);
            }
          });
          if (this.compositionIds && this.compositionIds.length) {
            this.paramsComposition = { _id: this.compositionIds }
          }
          if (this.uuids && this.uuids.length) {
            this.paramsScreen = { uuid: this.uuids }
          }
        }
      });
      this.dynamicContentEntranceService.find(0, 100, { OwnerCustomerID: this.customerId }).then(dynamicEntrances => {
        if (dynamicEntrances && dynamicEntrances.data && dynamicEntrances.data.length) {
          this.dynamicEntrances = dynamicEntrances.data;
        } else {
          this.organisationService.find(0, 100, { organisationCustomerId: this.customerId }).then(org => {
            if (org && org.data && org.data[0]) {
              this.dynamicContentEntranceService.find(0, 100, { OwnerOrganisationID: org.data[0].OrganisationID }).then(dynamicEntrances2 => {
                console.log('dynamicContent is connected via owner organisation id  - should not? : ', dynamicEntrances2);
              })
            }

          })
        }
      });

    });
  }

  onDetailPackage(event) {
    this.router.navigate(['packages', event.row._id])
  }

  onDetailScreen(event) {
    this.router.navigate(['angie-screens', event.row._id])
  }

  onDetailDynamicContent(event) {
    this.myOrganisationService.get(event.row.OwnerOrganisationID).then(organisation => {
      if (!organisation) {
        this.snackbar.open('you have no access to this organisation');
        return;
      }
      this.messengerService.setOrganisation(organisation);
      console.log('should set outlet name to: ', organisation.name);
      setTimeout(() =>
        this.router.navigate([{ outlets: { org: organisation.name, primary: 'dynamic-content' } }],
          { queryParams: { entranceId: event.row._id } }
        ), 1);
    });

  }

  onDetailComposition(event) {
    this.router.navigate(['compositions', event.row._id])
  }

  private createPageActions(): void {
    this.pageActions = [
      new PageAction({
        icon: 'subdirectory_arrow_left',
        title: 'Overview Customers',
        callback: () => {
          this.router.navigate(['organisation-customers']);
        }
      }),
      new PageAction({
        icon: 'edit',
        title: 'Edit Customer',
        callback: () => {
          this.router.navigate(['organisation-customers', this.customer._id, 'edit']);
        }
      }),
      new PageAction({
        icon: 'info',
        title: 'Statistik',
        callback: () => {
          this.router.navigate(['analytics', 'ibex4', this.customer._id]);
        }
      })
    ]
  }
}
